import { useEffect, useState } from 'react';
import { subscribeMeterTable, getLatestTableSnapshot } from './meterSocket';

const DEFAULT_METER_ID = 'TEST_1_1';

export default function useMeterTable({ meterId = DEFAULT_METER_ID, skip = false } = {}) {
    const [state, setState] = useState({ columns: [], rows: [] });

    useEffect(() => {
        if (skip) {
            setState({ columns: [], rows: [] });
            return undefined;
        }

        const cached = getLatestTableSnapshot(meterId);
        if (cached && !cached.error) setState({ columns: cached.columns || [], rows: cached.rows || [] });

        const handleSnapshot = (snapshot) => {
            if (!snapshot || snapshot.error) return;
            setState({ columns: snapshot.columns || [], rows: snapshot.rows || [] });
        };

        return subscribeMeterTable(meterId, handleSnapshot);
    }, [meterId, skip]);

    return state;
}
